// Media kind for a Raw Footage clip — video vs audio, derived from the file name.
//
// The API returns `mediaKind` on every footage row (see lib/mediaKind.js on the
// API, which is the source of truth). These helpers exist for the two places the
// browser has to decide before a row exists: the upload dropzone's allowlist,
// and rendering a row that predates the API field.

export const VIDEO_EXTS = ['mp4', 'mov', 'avi', 'mkv', 'm4v'];
// No 'aac': AWS Transcribe does not accept a bare ADTS .aac stream, so it must
// not be uploadable. 'm4a' is the AAC container Transcribe does accept.
export const AUDIO_EXTS = ['mp3', 'wav', 'm4a', 'flac', 'ogg'];

// For the <input accept> attribute: ".mp4,.mov,…"
export const ACCEPT_ATTR = [...VIDEO_EXTS, ...AUDIO_EXTS].map(e => `.${e}`).join(',');

// The dropzone hint, generated from the lists above so it can never advertise a
// format the allowlist no longer accepts.
export const SUPPORTED_HINT =
  `Video: ${VIDEO_EXTS.map(e => e.toUpperCase()).join(', ')}` +
  ` · Audio: ${AUDIO_EXTS.map(e => e.toUpperCase()).join(', ')}`;

const MEDIA_RE = new RegExp(`\\.(${[...VIDEO_EXTS, ...AUDIO_EXTS].join('|')})$`, 'i');
const AUDIO_RE = new RegExp(`\\.(${AUDIO_EXTS.join('|')})$`, 'i');

export function isMediaFile(name)  { return MEDIA_RE.test(name || ''); }
export function isAudioName(name)  { return AUDIO_RE.test(name || ''); }

// 'audio' | 'video'. Trusts the API's mediaKind when present, otherwise derives
// it from the file name so older rows still render correctly.
export function mediaKindOf(row) {
  if (row?.mediaKind) return row.mediaKind;
  return isAudioName(row?.fileName) ? 'audio' : 'video';
}

// Uppercase extension for the flat placeholder tile ("MP3", "WAV").
export function extLabel(name) {
  const m = /\.([A-Za-z0-9]{1,6})$/.exec(name || '');
  return m ? m[1].toUpperCase() : 'FILE';
}
